<template>
  <div class="AddRegistration">
    <header class="modal-header">
      <span v-if="actionAdding" class="entity-title">
        {{$t("registration.addRegistrations")}}
      </span>
      <span v-if="!actionAdding" class="entity-title">
        {{$t("registration.updateRegistration")}}
      </span>
    </header> 

    <div class="content">
      <div class="statusMessage w3-panel errorBox w3-round" v-show="showStatusMessage">{{statusMessage}}</div>
      <label v-if="actionAdding">
        {{$t("registration.playerType")}}
        <div class="radioContainer" >
          <div class="radio"><input type="radio" name="playerType" id="1" @click="toggleFields('fed')" checked> {{$t("registration.federationPlayer")}}</div>
          <div class="radio"><input type="radio" name="playerType" id="2" @click="toggleFields('new')"> {{$t("registration.newPlayer")}}</div>
        </div>
      </label>

      <div class="inputFields" v-show="showingFederationFields">
        <label>club filter</label>
          <Multiselect
            v-model="selectedClub"
            :placeholder="$t('registration.selectClub')"
            label="name" 
            valueProp="clubId"
            trackBy="name"
            @search-change="loadClubs"
            :options="clubs"
            :filterResults="false"
            :searchable="true" />
        <label>{{$t("tournament.player")}}</label>
          <input type="text" v-model.lazy="personSearchString" v-debounce="1000" :placeholder="$t('persons.search')">
          <div v-if="isPersonsLoading" class="spincontainer">
            <font-awesome-icon icon="cog" class="fa-spinner fa-spin icon" /> {{$t("registration.loading")}}
          </div>

<!--
        <label>
          toevoegen aan groep
          <select v-model="_selectedGroup">
            <option :v-for="(group in groups)" :value="group.groupId" :key="group.groupId">{{group.Name}}</option>
          </select>
        </label>
-->
        <persons-list v-if="persons != null" 
            :persons="persons" 
            :listType="'Select'"
            :optionSelectAll="true"
            v-on:personListChanged="personListChanged"></persons-list>

        <div class="buttons">
          <button :class="{'button-inactive': addingInProgress || !personSelected, 'button-default': !addingInProgress && personSelected}" @click="addAndNewPerson">{{$t("app.actions.addAndNew")}}</button>
        </div>
        <div class="buttons">
          <button :class="{'button-inactive': addingInProgress || !personSelected, 'button-default': !addingInProgress && personSelected }" :disabled="addingInProgress" @click="addFederationParticipants">{{$t("app.actions.add")}}</button>
          <button class="button-default" @click="cancel">{{$t("app.actions.cancel")}}</button>
        </div>
      </div>

      <div class="inputFields" v-show="!showingFederationFields">
        <label>
          {{$t("registration.name")}}
          <input v-model="candidate.name" class="theme-input" type="text" placeholder="naam">
        </label>
        <label>
          {{$t("registration.estimatedELO")}}
          <input v-model="candidate.latestRating" class="theme-input" type="number" placeholder="geschatte sterkte">
        </label>
        <label>
          {{$t("registration.federationNumber")}}
          <input v-model="candidate.federationNumber" class="theme-input" type="text" placeholder="bondsnummer">
        </label>
        <div class="buttons" v-if="actionAdding">
          <button :class="{'button-inactive': addingInProgress || !newPlayersFieldsFilled, 'button-default': !addingInProgress && newPlayersFieldsFilled }" @click="addAndNewPerson">{{$t("app.actions.addAndNew")}}</button>
        </div>
        <div class="buttons">
          <button v-if="actionAdding" :class="{'button-defauld inactive': addingInProgress || !newPlayersFieldsFilled, 'button-default': !addingInProgress && newPlayersFieldsFilled }" @click="createNewPerson">{{$t("app.actions.add")}}</button>
          <button v-if="!actionAdding" :class="{'button-default inactive': addingInProgress || !newPlayersFieldsFilled, 'button-default': !addingInProgress && newPlayersFieldsFilled }" @click="updatePerson">{{$t("app.actions.edit")}}</button>
          <button class="button-default" @click="cancel">{{$t("app.actions.cancel")}}</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {RestAPI} from "@aws-amplify/api-rest";
import PersonsList from "@/components/players/PersonsList";
import Multiselect from '@vueform/multiselect';

const apiName = 'api';
const myInit = { 
  response: false, 
};


export default {
  name: 'AddRegistration',
  components: {Multiselect, PersonsList},
  props: {
    participant: {
        type: Object,
        required: false
      },
    action: String,
    groups: Array
  },
  data: function () {
    return {
      adding: false,
      afterAddAndNew: false,
      awaitingPersonSearch: false,
      candidate: {federationCode:0},  // Person to be created
      clubs: [],
      person: {},
      persons: [],    // Used for search
      personsLoading: false,
      personSearchString: "",
      personsToBeAdded: [], // Person ID's as selected in de PersonList
      possibleNewRegistrations: [],
      registration: {tournamentId: this.$route.params.tournamentId},
      showingFederationFields: true,
      showingStatusMessage: false,
      selectedClub: "",
      selectedGroup: -1,
      statusMessage: ""
    }
  },
  emits: [ 'cancel', 'ok' ],
  beforeMount() {
    if (this.action == "edit") {
      //this.loadPerson(); Seems unnecessary, as this property is delivered by the caller already.
      // only check if we need the candidate to be filled. but we could do that without loading.
      this.candidate = this.participant.person;
      this.toggleFields('new'); // choice of new and fed, meaning handmade or knsb player.
    }
  },
  computed: {
    actionAdding() {
      return this.action == "add";
    },
    addingInProgress() {
      return this.adding;
    },
    newPlayersFieldsFilled() {
      return this.candidate.name != ""
            && this.candidate.latestRating != "";
    },
    personSelected() {
      return this.personsToBeAdded.length > 0;
    },
    showStatusMessage() {
      return this.showingStatusMessage;
    },
    isPersonsLoading() {
      return this.personsLoading;
    },
    _selectedGroup: {
      get() {
        return this.selectedGroup;
      },
      set(newVal) {
        this.selectedGroup = newVal;
      }
    },
  },
  updated: function () {
    this.$nextTick(function () {
      this.loading=false;
    })
  },
  watch: {
    personSearchString: function () {
      console.log("Watcher initiated" )
      this.loadPersons();
    },
    selectedClub: function(oldVal, newVal) {
      if (oldVal != newVal) {
        this.loadPersons();
      }
    }
  },
  methods: {
    addAndNewPerson() {
      let that = this;
      this.statusMessage = "Adding...";
      this.adding = true;
      this.afterAddAndNew = true;
      const myPersonInit = { 
        headers: { 'Authorization': 'Bearer '+ this.$CAUser.getToken()},
        body: this.candidate,
        response: false, 
      };
      //Save new person
      let path = '/person/';
      RestAPI
        .post(apiName, path, myPersonInit)
        .then(response => {
            that.person = response;
            console.log("Response: "+ that.person.personId);
            that.registration.personId = that.person.personId;
            that.registration.startingElo = this.candidate.latestRating;
            that.saveParticipation(false);
            //Succes

            that.candidate.name = "";
            that.candidate.latestRating = "";
            that.candidate.federationNumber = "";

            // Show succes message for like 3 seconds
            that.statusMessage = "Added person: " + that.person.name;
            console.log("Message uit hier 1");
            that.showingStatusMessage = true;
            console.log("Message uit hier 2");
            console.log("Message uit hier 3");
            that.adding = false;
            console.log("Message uit hier");
            setTimeout(that.hideStatusMessage, 5000);
        })
        .catch(error => {
          that.statusMessage = "error occured, participant not added";
          that.showingStatusMessage = true;
          console.log("Message uit bij fout");
          setTimeout(that.hideStatusMessage, 5000);
          console.log(error.response);
          that.adding = false;
        });
    },

    addFederationParticipants: function() {
      console.log("Selected persons: " + this.personsToBeAdded);

      this.personsToBeAdded.forEach((personId, index) => {
        if (index < (this.personsToBeAdded.length-1))
          this.saveParticipationbyPersonID(personId, false);
        else
          this.saveParticipationbyPersonID(personId, true);
      });
    },

    cancel: function() {
      if (this.afterAddAndNew)
        this.$emit('ok');
      else
        this.$emit('cancel');
    },
    
    createNewPerson() {
      let that = this;
      this.adding = true;
      this.statusMessage = "adding new participant...";
      const myPersonInit = { 
        headers: { 'Authorization': 'Bearer '+ this.$CAUser.getToken()},
        body: this.candidate,
        response: false, 
      };
      //Save new person
      console.log("Save new person");
      let path = '/person/';
      RestAPI
        .post(apiName, path, myPersonInit)
        .then(response => {
            that.person = response;
            console.log("Response: "+ that.person.personId);
            that.registration.personId = that.person.personId;
            that.registration.startingElo = this.candidate.latestRating;
            that.saveParticipation(true);

            that.statusMessage = "person added: " + that.person.name + ".\n Please be patient, adding participant to existing rounds...";
            that.showingStatusMessage = true;
        })
        .catch(error => {
          console.log(error.response);
          that.statusMessage = "error occured, participant not added";
          that.showingStatusMessage = true;
          that.adding = false;
          setTimeout(that.hideStatusMessage, 5000);
        });
    },

    hideStatusMessage() {
      console.log("hiding message again");
      this.showingStatusMessage = false;
    },

    loadClubs: function(query) {
      if (query != "") {
        let that = this
        let fullPath = "/club/?name=" + query;
        RestAPI
          .get(apiName, fullPath, myInit)
          .then(response => {
            console.log("Clubs loaded from " + fullPath )
            that.clubs = response;
            return JSON.stringify(that.clubs);
          })
          .catch(error => {
            console.log(error.response);
          });
      }
    },

    loadPerson() {
      console.log("participant: " + JSON.stringify(this.participant));
      // This function loads a person, when this component is loaded in edit state
      let that = this
      let completePath = "/person/" + this.participant.personId;
      RestAPI
        .get(apiName, completePath, myInit)
        .then(response => {
          that.candidate = response;            
          console.log("Person loaded: " + JSON.stringify(that.candidate));
        })
        .catch(error => {
          if (error.status !== 404) {
            console.log("ERROR", JSON.stringify(error));
          }
        });
    },

    loadPersons() {
      let that = this
      if (this.personSearchString != "" || this.selectedClub != null) {
        this.personsLoading = true;
        let fullPath = "/person";
        if (this.selectedClub != "") {
          console.log(this.selectedClub);
          if (this.personSearchString != "" )
            fullPath = fullPath + "?clubId=" + this.selectedClub + "&name=" + encodeURIComponent(this.personSearchString);
          else
            fullPath = fullPath + "?clubId=" + this.selectedClub;
        } else
          fullPath = fullPath + "?name=" + encodeURIComponent(this.personSearchString);
        RestAPI
          .get(apiName, fullPath, myInit)
          .then(response => {
            console.log("Persons loaded from " + fullPath )
            console.log("Persons loaded from " + JSON.stringify(response) )
            that.persons = response
            that.personsLoading = false;
          })
          .catch(error => {
            console.log(error.response);
          });
      } else {
        this.persons = null;
      }

    },

    toggleFields (playerType) {
      this.showingFederationFields = (playerType == "fed");
    },

    personListChanged: function(newVal) {
      //console.log("geselecteerd: " + newVal);
      //store the personID's selected in the PersonList.
      //After an OK, we will save according to this list
      this.personsToBeAdded = newVal;
    },

    saveParticipationbyPersonID: function(personId, emitAfterSave) {
      var localRegistration = {tournamentId: this.$route.params.tournamentId};
      localRegistration.personId = personId;
      let that = this;
      //Save participation
      let path = '/participant/';
      const myParticipantInit = { 
        headers: { 'Authorization': 'Bearer '+ this.$CAUser.getToken()},
        body: localRegistration,
        response: false, 
      };
      RestAPI
        .post(apiName, path, myParticipantInit)
        .then(() => {
          if (emitAfterSave)
            that.adding = false;
            that.$emit('ok');
          })
        .catch(error => {
          console.log(error.response);
        });
    },

    saveParticipation: function (emitAfterSave) {
      //Save participation
      let path = '/participant/';
      let that = this;
      const myParticipantInit = { 
        headers: { 'Authorization': 'Bearer '+ this.$CAUser.getToken()},
        body: this.registration,
        response: false, 
      };
      RestAPI
        .post(apiName, path, myParticipantInit)
        .then(() => {
          if (emitAfterSave)
            that.adding = false;
            that.$emit('ok');
          })
        .catch(error => {
          console.log(error.response);
        });
    },

    updateParticipation: function (emitAfterSave) {
      //Update participation
      let path = '/participant/' + this.participant.participantId;
      const myParticipantInit = { 
        headers: { 'Authorization': 'Bearer '+ this.$CAUser.getToken()},
        body: this.participant,
        response: false, 
      };
      RestAPI
        .put(apiName, path, myParticipantInit)
        .then(() => {
          if (emitAfterSave)
            console.log("updateParticipation Done, ok submitted.");
            this.$emit('ok');
          })
        .catch(error => {
          console.log(error.response);
        });
    },

    updatePerson() {
      let that = this;
      this.adding = true;
      this.statusMessage = "updating...";
      console.log("trying to update to: " + JSON.stringify(this.candidate));
      const myPersonInit = { 
        headers: { 'Authorization': 'Bearer '+ this.$CAUser.getToken()},
        body: this.candidate,
        response: true, 
      };
      //Update person
      let path = '/person/' + this.candidate.personId;
      RestAPI
        .put(apiName, path, myPersonInit)
        .then(() => {
            //console.log("Response: " + that.person.personId);
            console.log("StartingELO: " + that.candidate.latestRating);
            that.participant.startingElo = that.candidate.latestRating;
            that.updateParticipation(true);
            that.adding = false;

            that.statusMessage = "update ready. ";
            that.showingStatusMessage = true;
          console.log("Toch uit");
            setTimeout(that.hideStatusMessage, 5000);
        })
        .catch(error => {
          console.log(error.response);
          that.statusMessage = "error occured, person not updated";
          that.showingStatusMessage = true;
          that.adding = false;
          console.log("Deze fout misschien?");
          setTimeout(that.hideStatusMessage, 5000);
        });
    }
  }
}

</script>

<style src="@vueform/multiselect/themes/default.css"></style>

<style scoped>

.radioContainer {
  display: flex;
  flex-direction: row;
}

.imgbtn {
    transition: border .3s linear, color .3s linear, background-color .3s linear;
}
.imgbtn:hover {
    color: #5681c2;
}
input[type="radio"] {
 margin: 0;
 margin-top: 8px;
 padding: 0;
 width: 12px;
 height: 12px;
}
.radio {
  margin: 8px;
}
/* mobile */
@media screen and (max-width: 600px) {
  .content {
    padding: 0vw 2vw;
  }
}

/* ipad */
@media screen and (min-width: 601px) and (max-width: 1280px) {
  .content {
    padding: ovw 1vw;
  }
}

/* laptop */
@media screen and (min-width: 1281px) {
  .content {
    padding: 0vw 1vw;
  }
}
</style>
